var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"pt-0 pl-0 pr-0",attrs:{"id":"app","fluid":_vm.$vuetify.breakpoint.width <= 1920}},[_c('router-view'),_c('notify')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }